import apiClient from './ApiClient';

export class TimeSlotRepository {
	constructor(client) {
		this.client = client;
		this.basePath = '/api/time-slots';
	}

	/**
	 * Create a new time slot - Admin only
	 * @param {Object} payload
	 * @param {string} payload.dateSlotId - UUID of the date slot
	 * @param {string} payload.startTime - Format HH:mm
	 * @param {string} payload.endTime - Format HH:mm
	 * @param {number} payload.capacity - Must be > 0
	 * @param {Array<string>} payload.serviceItemIds - Array of service item UUIDs
	 * @returns {Promise<{id: string}>}
	 */
	async create(payload) {
		return this.client.post(this.basePath, payload);
	}

	/**
	 * Update a time slot - Admin only
	 * @param {string} id - Time slot UUID
	 * @param {Object} updates - Fields to update
	 * @param {boolean} [updates.blocked] - Whether the slot is blocked
	 * @returns {Promise<{success: boolean}>}
	 */
	async update(id, updates) {
		return this.client.patch(`${this.basePath}/${id}`, updates);
	}

	/**
	 * Copy time slots from one date to multiple other dates - Admin only
	 * @param {Array<string>} dateSlotIds - Array of target date slot UUIDs to copy to
	 * @param {Array<Object>} timeSlots - Array of time slot definitions to copy
	 * @param {boolean} [skipInvalidDates] - If true, process valid dates and report failures instead of throwing
	 * @returns {Promise<Object>} Result object with processed count and per-date results
	 */
	async copy(dateSlotIds, timeSlots, skipInvalidDates = true) {
		return this.client.post(`${this.basePath}/copy`, {
			dateSlotIds,
			timeSlots,
			skipInvalidDates
		});
	}
}

export default new TimeSlotRepository(apiClient);
